import { HStack, IconButton, Text } from '@chakra-ui/react'
import { themeColors } from 'theme'

import { CheckmarkIcon, TrashIcon } from 'components/SVGS'

import { Props } from './types'

export const CustomFileCheck: React.FC<Props> = ({ onClick, text }) => {
  const { card: { bgBorderColor } } = themeColors

  return (
    <HStack
      bg={bgBorderColor}
      px={{ base: 0, md: 2 }}
      justifyContent={'space-around'}
      spacing={2} alignItems={'center'}
      borderRadius={'6px'}
      maxW={{ base: 'full', md: '220px' }}
      w={{ base: 'full', md: 'auto' }}
      h={'40px'}>
      <CheckmarkIcon size={7} />
      <Text variant={'SM'} noOfLines={1} textAlign={'center'}>{text}</Text>
      <IconButton onClick={onClick}
        variant={'unstyled'}
        aria-label='icon'
        h={'auto'}
        minW={'auto'}
        fontSize={{ base: 'xs', md: 'md' }}
        icon={<TrashIcon size={5} />}
      />
    </HStack>
  )
}
